import { mapGetters } from 'vuex'

import { manuscript } from '@/api/manuscript'
import help from '@/utils/help'
import zip from '@/utils/zip'
import { DECISION_STATUS } from '@/utils/dict'
import customerReviewQuestion from '@/components/question.vue'

export default {
  data() {
    return {
      responseData: {},
      showAuthor: true,
      showManuscriptFiles: true,
      showSuggestReview: true,
      showDecision: true,
      showReview: true,
      showManuscript: true,
      showMoreAuthor: false,
      // download: help.download,
      activeKey: '',
      activeData: {},
      DECISION_STATUS,
      reviewReport: [],
      suggestList: [],
      opposeList: []
    }
  },
  components: {
    customerReviewQuestion
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      title: 'getTitle',
      domain: 'getDomain',
      country: 'getCountry'
    })
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const { id, sign } = this.$route.query
      const data = await manuscript.query(id, { sign })
      let disTotal = 0
      if (data.discountDetailList && data.discountDetailList.length > 0) {
        data.discountDetailList.forEach(ele => {
          disTotal += ele['discount']
        })
        data.__diacountTotal = disTotal
      }
      this.responseData = data
      if (
        this.responseData.reviewerList &&
        this.responseData.reviewerList.length > 0
      ) {
        this.suggestList = this.responseData.reviewerList.filter(item => {
          return item.type === 'SUGGEST'
        })
        this.opposeList = this.responseData.reviewerList.filter(item => {
          return item.type === 'OPPOSE'
        })
      }
      const report = await manuscript.allReport(id)

      this.reviewReport = report
      this.activeKey = 0
      this.activeData = report && report[0]
      this.activeData &&
        this.activeData.reviewerDecisionList &&
        this.activeData.reviewerDecisionList.map((itemRep, indexRep) => {
          itemRep['showReport'] = indexRep == 0 ? true : false
        })
    },
    changeReport(item, index) {
      this.activeKey = index
      this.activeData = item
      this.activeData &&
        this.activeData.reviewerDecisionList &&
        this.activeData.reviewerDecisionList.map((itemRep, indexRep) => {
          itemRep['showReport'] = indexRep == 0 ? true : false
        })
    },
    download(item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(item, 'author_files.zip')
      }
    },
    showReport(itemRep, indexRep) {
      itemRep['showReport'] == undefined
        ? (itemRep['showReport'] = indexRep == 0 ? true : false)
        : (itemRep['showReport'] = !itemRep['showReport'])
      this.activeData = JSON.parse(JSON.stringify(this.activeData))
    }
  }
}
